import { defineActions } from './defineActions'

/**
 * Dictation and report. Action names start with Report. (the section's components live in
 * src/components/CaseDictationReport and are shared with other modules, so they carry no module
 * prefix); the IME-only Specialist Dashboard upload modals use Ime.Report.
 *
 * The footer Save of the section is Ime.Dictation.Save (ime-page.ts). Every "Resend" below opens
 * a confirm modal; the email is sent from its OK, inside the same action.
 */
export const dictationReportActions = defineActions({
  // Dictation files from specialist
  'Report.Dictation.ResendReceiptToSpecialist': {
    label: 'Resend dictation receipt to specialist',
    area: 'Dictation & report',
  },
  'Report.Dictation.ResendReceiptToStaff': {
    label: 'Resend dictation receipt to staff',
    area: 'Dictation & report',
  },
  'Report.Dictation.UploadVoiceRecording': {
    label: 'Upload voice recording',
    area: 'Dictation & report',
    description:
      'Uploads a recorded dictation; the file is linked to the case by the next Save.',
  },

  // Dictation received / typist
  'Report.Typist.ResendDictationFiles': {
    label: 'Resend dictation files to typist',
    area: 'Dictation & report',
  },
  'Report.Typist.ResendTypedReportToStaff': {
    label: 'Resend typed report to staff PIC',
    area: 'Dictation & report',
  },

  // Report draft
  'Report.Draft.ResendToSpecialist': {
    label: 'Resend report draft to specialist',
    area: 'Dictation & report',
  },
  'Report.Draft.ResendCausationReview': {
    label: 'Resend for causation review',
    area: 'Dictation & report',
  },

  // Reviewed / completed report
  'Report.ICare.ResendRequirementToStaff': {
    label: 'Resend iCare requirement to staff PIC',
    area: 'Dictation & report',
  },
  'Report.ICare.ResendRequirementToSpecialist': {
    label: 'Resend iCare requirement to specialist',
    area: 'Dictation & report',
  },
  'Report.Reviewed.ResendNoticeToStaff': {
    label: 'Resend reviewed/completed report notice to staff',
    area: 'Dictation & report',
  },
  'Report.Reviewed.ResendNoticeToSpecialist': {
    label: 'Resend reviewed/completed report notice to specialist',
    area: 'Dictation & report',
  },

  // Report QA check (AI)
  'Report.QA.Run': {
    label: 'Show report QA result',
    area: 'Dictation & report',
    description: 'Runs (or reads the cached) AI report QA check.',
  },
  'Report.QA.Refresh': {
    label: 'Clear cache and reload report QA result',
    area: 'Dictation & report',
  },
  'Report.QA.ChangeFile': {
    label: 'Change report QA check file',
    area: 'Dictation & report',
  },

  // Final / amended report
  'Report.Final.ResendToSpecialist': {
    label: 'Resend final report to specialist',
    area: 'Dictation & report',
  },
  'Report.Final.ResendToContact1': {
    label: 'Resend final report to report receiving contact 1',
    area: 'Dictation & report',
  },
  'Report.Final.ResendToContact2': {
    label: 'Resend final report to report receiving contact 2',
    area: 'Dictation & report',
  },
  'Report.Amended.ResendToContact1': {
    label: 'Resend amended report to report receiving contact 1',
    area: 'Dictation & report',
  },
  'Report.Amended.ResendToContact2': {
    label: 'Resend amended report to report receiving contact 2',
    area: 'Dictation & report',
  },

  // Specialist Dashboard upload modals (IME)
  'Ime.Report.SpecialistUploadDictation': {
    label: 'Upload specialist dictation',
    area: 'Dictation & report',
    description:
      'Save of the Specialist Dictation modal (Specialist Dashboard).',
  },
  'Ime.Report.SpecialistUploadFinalReport': {
    label: 'Upload final report/notes',
    area: 'Dictation & report',
    description:
      'Save of the Upload Final Report/Notes modal (Specialist Dashboard).',
  },
})
